// extracted by mini-css-extract-plugin
export default {"tabLinks":"styles_tabLinks__gUUCq","activeLink":"styles_activeLink__nG6Js"};